import { Slide, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { memo } from 'react'

const SlideTransition = props => {
  return <Slide {...props} direction='down' />
}

const Toaster = ({ color, icon, message, onClose, open, autoHideDuration }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{ marginTop: '6rem' }}
    >
      <Alert onClose={onClose} severity={icon} color={color} variant='filled'>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default memo(Toaster)
